// @flow

/* eslint-disable new-cap */
import { get } from 'lodash';
import {
  FETCH_BOOKING_DETAILS,
  FETCH_BOOKING_DETAILS_RESOLVED,
  FETCH_BOOKING_DETAILS_REJECTED,
  CLEAR_BOOKING_DETAILS,
} from 'Store/member-space/booking/booking.constants';

import createReducer from 'Store/utils/createReducer';

const initialState = {
  data: null,
  isLoading: true,
  isLoaded: false,
  isOnError: false,
  errorResponse: null,
};

export default createReducer(initialState, {
  [FETCH_BOOKING_DETAILS](state: ReduxState): ReduxState {
    return {
      ...state,
      isLoading: true,
    };
  },
  [FETCH_BOOKING_DETAILS_RESOLVED](state: ReduxState, action): ReduxState {
    return {
      ...state,
      data: get(action, 'payload.userBooking'),
      isLoaded: true,
      isLoading: false,
    };
  },
  [FETCH_BOOKING_DETAILS_REJECTED](state: ReduxState, action): ReduxState {
    return {
      ...state,
      isLoading: false,
      isLoaded: true,
      isOnError: true,
      errorResponse: { errors: action.payload.errors },
    };
  },
  [CLEAR_BOOKING_DETAILS](): ReduxState {
    return initialState;
  },
});
